import { KnownDeliveryState } from '@groundfloor-platform/mgmt-service-g-sdk';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { Paths, ProjectPathParams } from '../../../../../app/router/app.router';
import { DeliveryStatusCountCard } from './delivery-status-count-card.component';

export const DeliveryStatusCountGrid = React.memo(function StatusCountGrid({
  params
}: {
  params: ProjectPathParams<Paths.dashboard>;
}) {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.only('xs'));
  const isSm = useMediaQuery(theme.breakpoints.only('sm'));

  const spacing = isXs ? 2 : 3;

  return (
    <Grid
      container
      spacing={spacing}
      sx={{ flexDirection: isSm || isXs ? 'column' : 'row' }}
      wrap={isSm || isXs ? 'wrap' : 'nowrap'}
      style={isXs ? { overflow: 'hidden' } : undefined}
    >
      <Grid
        container
        spacing={spacing}
        direction={'row'}
        wrap="nowrap"
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <Grid container>
          <DeliveryStatusCountCard params={params} state={KnownDeliveryState.Delivered} size="small" />
        </Grid>
        <Grid container>
          <DeliveryStatusCountCard params={params} state={KnownDeliveryState.Overdue} size="small" />
        </Grid>
      </Grid>
      <Grid
        container
        spacing={spacing}
        direction={'row'}
        wrap="nowrap"
        sx={{
          justifyContent: 'space-between'
        }}
      >
        <Grid container>
          <DeliveryStatusCountCard params={params} state={KnownDeliveryState.Cancelled} size="small" />
        </Grid>
        <Grid container>
          <DeliveryStatusCountCard params={params} state={KnownDeliveryState.Collected} size="small" />
        </Grid>
      </Grid>
    </Grid>
  );
});
